import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, createElementVNode, createBlock, createCommentVNode, normalizeProps, mergeProps, withCtx, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es211.js';
/* empty css                        */
import { useBlockPositioning } from './basler-components.es419.js';

const _hoisted_1 = { class: "headline-block__inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeadlineBlock",
  props: {
    headline: {},
    cols: { default: 6 },
    colsCentered: { type: Boolean, default: true },
    contentCentered: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { positioningClassNames } = useBlockPositioning(
      "headline-block",
      props.cols,
      props.colsCentered,
      props.contentCentered
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["headline-block", unref(positioningClassNames)])
      }, [
        createElementVNode("div", _hoisted_1, [
          _ctx.headline ? (openBlock(), createBlock(_sfc_main$1, normalizeProps(mergeProps({ key: 0 }, _ctx.headline)), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.headline.content), 1)
            ]),
            _: 1
          }, 16)) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
